'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var injectSheet = require('react-jss');
var classNames = require('classnames');
var CloseIcon = require('react-icons/lib/fa/times-circle');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var faCheck = require('@fortawesome/pro-solid-svg-icons/faCheck');
var faExclamation = require('@fortawesome/pro-solid-svg-icons/faExclamation');
var faInfo = require('@fortawesome/pro-solid-svg-icons/faInfo');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var CloseIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var _excluded = ["classes", "hideTitle", "type", "children", "onClose", "className", "statusText"];
var styles = {
  container: {
    padding: '16px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold'
  },
  icon: {
    width: '32px',
    height: '32px',
    margin: '0 16px 0 0',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0'
  },
  title: {
    margin: '0 4px 0 0',
    fontWeight: 'bold'
  },
  success: {
    color: '#48640c',
    backgroundColor: '#f8faf5',
    '& $icon': {
      background: 'rgb(72 100 12 / 15%)'
    }
  },
  info: {
    color: '#0071c2',
    backgroundColor: '#f1f7fe',
    '& $icon': {
      background: 'rgb(0 113 194 / 14%)'
    }
  },
  warning: {
    color: '#996600',
    backgroundColor: '#fef7ec',
    '& $icon': {
      background: 'rgb(153 102 0 / 15%)'
    }
  },
  error: {
    color: '#db3915',
    background: '#f9d9d3',
    '& $icon': {
      background: 'rgb(219 57 21 / 18%)'
    }
  },
  text: {
    margin: '0',
    flex: '1',
    font: 'var(--body-)',
    fontWeight: 'bold',
    '& a': {
      textDecoration: 'underline',
      color: 'currentColor'
    }
  },
  closeButton: {
    width: '16px',
    height: '16px',
    margin: '0 0 0 20px',
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, .4)',
    alignSelf: 'flex-start',
    '& > svg': {
      display: 'block',
      width: '100%',
      height: '100%'
    }
  }
};
var alertsMap = {
  success: {
    icon: /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faCheck.faCheck
    }),
    title: 'Success'
  },
  info: {
    icon: /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faInfo.faInfo
    }),
    title: 'Info'
  },
  warning: {
    icon: /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faExclamation.faExclamation
    }),
    title: 'Warning'
  },
  error: {
    icon: /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faExclamation.faExclamation
    }),
    title: 'Error'
  }
};

var Alert = function Alert(_ref) {
  var classes = _ref.classes,
      hideTitle = _ref.hideTitle,
      type = _ref.type,
      children = _ref.children,
      onClose = _ref.onClose,
      className = _ref.className,
      statusText = _ref.statusText,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);

  var alertData = alertsMap[type];
  return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
    className: classNames__default["default"](classes.container, classes[type], className)
  }, props), /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.icon
  }, alertData.icon), /*#__PURE__*/React__default["default"].createElement("p", {
    className: classes.text
  }, !hideTitle && /*#__PURE__*/React__default["default"].createElement("strong", {
    className: classes.title
  }, statusText || alertData.title + ':'), /*#__PURE__*/React__default["default"].createElement("span", null, children)), onClose && /*#__PURE__*/React__default["default"].createElement("span", {
    onClick: onClose,
    role: "button",
    tabIndex: "0",
    className: classes.closeButton
  }, /*#__PURE__*/React__default["default"].createElement(CloseIcon__default["default"], null)));
};

Alert.propTypes = {
  /** Type of the alert */
  type: PropTypes__default["default"].oneOf(['success', 'info', 'warning', 'error']).isRequired,

  /** Callback to be fired when user clicks on close button */
  onClose: PropTypes__default["default"].func
};
var index = injectSheet__default["default"](styles)(Alert);

module.exports = index;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/alert/index.js